import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import type { ClassValue } from "clsx";

export type Prettify<T> = {
  [K in keyof T]: T[K];
} & {};


export function cn(...inputs: Array<ClassValue>) {
  return twMerge(clsx(inputs));
}
